import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

export default function InfoStep02() {

  const { getValues } = useFormContext()
  const { step02 } = getValues()

  return (
    <>
      <Box display={'flex'} gap={4} flexWrap={'wrap'}>
        <TableView
          title="Público"
          text={`${step02.publico.tipo_publico}${step02.publico.codigo_publico} - ${step02.publico.nome_pessoa}`}
        />
        {
          step02.fazenda !== "" &&
          <TableView
            title="Fazenda"
            text={`${step02.fazenda.apelido} - ${step02.fazenda.nome}`}
          />
        }
        {
          step02.loja !== "" &&
          <TableView
            title="Loja"
            text={`${step02.loja.id} - ${step02.loja.nome}`}
          />
        }
        <TableView
          title="Valor do lançamento"
          text={`${step02.valor}`}
        />
        <TableView
          title="Número"
          text={`${step02.nr_documento}/${step02.serie_documento}`}
        />
        <TableView
          title="Lote"
          text={`${step02.lote}`}
        />
        <TableView
          title="Histórico"
          text={`${step02.historico}`}
        />
      </Box>
    </>

  )
}

function TableView({ title, text }: TableViewProps) {
  return (
    <Box mb={1}>
      <Typography variant="subtitle2" color="textSecondary">
        {title}
      </Typography>
      <Typography variant="subtitle1">
        {text}
      </Typography>
    </Box>
  );
}

interface TableViewProps {
  title: string;
  text: string;
}